import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GridAction } from 'src/app/model/result-grid/grid-action';
import { ResultGridActionsService } from 'src/app/services/result-grid-actions.service';

@Component({
  selector: 'common-result-grid-actions',
  templateUrl: './result-grid-actions.component.html',
  styleUrls: ['./result-grid-actions.component.scss']
})
export class ResultGridActionsComponent implements OnInit {
  public placeholder: string = 'Actions';
  @Input() inputPlaceholder!: string;
  public gridActionItems: GridAction[] = [];
  @ViewChild("actionsDropDown") actionsDropDown: ElementRef<any> | undefined;

  constructor(private resultGridActionsService: ResultGridActionsService) { }

  ngOnInit(): void {
    if(this.inputPlaceholder) {
      this.placeholder = this.inputPlaceholder;
      this.resultGridActionsService.gridCancelItems.subscribe(data => {
        this.gridActionItems = data;
      })
    }
    else
    {
      this.resultGridActionsService.gridActionItems.subscribe(data => {
        this.gridActionItems = data;
      });
    }
    
  }

  setSelectedAction($event: any) {
    let selectedItem = this.gridActionItems.find((cat) => cat.value === $event.detail?.optionSelected.value);
    this.resultGridActionsService.callActionCallback(selectedItem?.callback);
    this.actionsDropDown?.nativeElement.resetSelectMenu();
  }

  callSingleAction() {
    this.resultGridActionsService.callActionCallback(this.gridActionItems[0].callback);
  }
}
